module.exports = __webpack_public_path__ + "static/media/IMG_4261.d5771cb4.PNG";